import {useSyncExternalStore} from 'react'
import {getRelaySessionUsage, subscribeRelayRegistry} from '@github-ui/ahp-relay/relay-registry'
import type {RelaySessionUsage} from '@github-ui/ahp-relay/session-usage'

/**
 * Reads the token totals and context-window occupancy the host has reported for
 * `taskId`. Read-only: it never acquires a relay, so it returns `undefined`
 * until some other consumer (e.g. the session timeline) has one connected.
 */
export function useRelaySessionUsage(taskId: string | undefined): RelaySessionUsage | undefined {
  return useSyncExternalStore(
    subscribeRelayRegistry,
    () => getRelaySessionUsage(taskId),
    () => undefined,
  )
}
